import { Action, State, StateContext, Store } from "@ngxs/store";
import { Injectable } from "@angular/core";
import { LocalizationService } from "src/app/services/localization/localization.service";
import { AlertService } from "src/app/shared/store/alert/alert.service";
import { DietService } from "../services/diet.service";
import { DietActions } from "./diet.actions";
import { Diet } from "../models/diet.model";
import { MappingUtilsService } from "src/app/services/utils/mapping-utils.service";
import { filter } from "rxjs";


export class DietStateModel {
    public diets: Diet[];
    public isLoadingDiets: boolean;
    public error: string;
  }

  const defaults = {
    diets: [],
    currentDiet: null,
    isLoadingDiets: false,
    error: null
  };

  @State<DietStateModel>({
    name: 'diet',
    defaults,
  })
  @Injectable()
  export class DietState {
    constructor(
      private alertService: AlertService,
      private localizationService: LocalizationService,
      private dietService: DietService,
      public store: Store
    ) {}

  @Action(DietActions.GetDiets)
  getDiets (ctx: StateContext<DietStateModel>, { }: DietActions.GetDiets) {
    return this.dietService.getDiets()
      .subscribe({
        next: (response) =>
          ctx.dispatch(new DietActions.GetDietsSuccess(response)),
        error: (error) =>
          ctx.dispatch(new DietActions.Error(error)),
      });
  }

  @Action(DietActions.GetDietsSuccess)
  getContractSuccess(ctx: StateContext<DietStateModel>, { diets }: DietActions.GetDietsSuccess) {
    const sorteredDiets = this.sortOtrosDiet(diets);
    ctx.patchState({
      diets: sorteredDiets,
      isLoadingDiets: false,
    });
  }

  @Action(DietActions.Error)
  onErrorOcurred(ctx: StateContext<DietStateModel>, {error}: DietActions.Error) {
    ctx.patchState({
      error: error,
      isLoadingDiets: false,
    });
    MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
  }

  private sortOtrosDiet(diets) {
    const filteredDiets = diets.filter(diet => diet.description !== 'Otros');
    filteredDiets.sort((a, b) => a.description.localeCompare(b.description));
    filteredDiets.push(diets.find(diet => diet.description === 'Otros'));
    return filteredDiets;
  }

  private getTitle() {
    return this.localizationService.translate('labels.diet');
  }
}
